module.exports = __webpack_public_path__ + "static/media/folder.30a30d83.svg";